import React, { useContext, useEffect } from 'react';
import { EventContext } from '../context/EventContext';
import { Link, useNavigate } from 'react-router-dom';
import { UserRoleContext } from '../context/UserRoleContext';
import { getEvent } from '../services/eventService';
import EventControlsPage from './EventControls';
import { ROLES } from '../constants/roles';
import { ROUTES } from '../constants/routes';
import { prettyDateTime } from '../services/formatter.service';


const EventOverview: React.FC<{}> = () => {
    const { currentEvent, setCurrentEvent } = useContext(EventContext);  // Assuming the event data is in context
    const { userRole } = useContext(UserRoleContext);
    const navigate = useNavigate();

    // Fetch events when the component mounts
    useEffect(() => {
        const fetchEvents = async () => {
            try {
                if (currentEvent) {
                    //update event
                    const event = await getEvent(currentEvent?.event_id);//(currentEvent?.event_id); // Fetch the events
                    setCurrentEvent(event); // Update the state with fetched events

                } else {
                    navigate(ROUTES.SWITCH_EVENTS);
                }
            } catch (error) {
                console.error("Error fetching event:", error); // Log any errors
            }
        };
        fetchEvents();
    }, []); // Empty dependency array ensures this runs once on mount

    // Handle the logic for no event being present
    const renderEventDetails = () => {
        if (currentEvent) {
            return (
                <div>
                    <div className='card' style={{ maxWidth: "900px"}}>
                        <h2>{currentEvent.event_name} - ({currentEvent.event_code})</h2>
                        {Boolean(currentEvent.is_locked) && <h4>***This event is locked because it is past its end date. If this is in error, please contact support.***</h4>}

                        <p><strong>Event Type:</strong> {currentEvent.event_type_name}</p>
                        <p><strong>Description:</strong> {currentEvent.event_description}</p>
                        <p><strong>Host:</strong> {currentEvent.host_name}</p>
                        <p><strong>Use Quick Cyne Up:</strong> {currentEvent.checkin_only ? 'Yes' : 'No, use invitation and checkin process'}</p>
                        {!currentEvent.checkin_only && (<p style={{marginLeft: '20px'}}><strong>Has Checkin:</strong> {currentEvent.has_checkin ? 'Yes' : 'No'}</p>)}
        
                        <p><strong>Location:</strong> {currentEvent.location || 'TBD'}</p>
                        <p><strong>Start Date - End Date:</strong> {prettyDateTime(new Date(currentEvent.start_date))} to {prettyDateTime(new Date(currentEvent.end_date))}</p>
                        {/* <p><strong>Billing Method:</strong> {currentEvent.use_billing_service ? 'Use System Billing' : 'Use Own Billing'}</p> */}
                        {/* <p><strong>Registration Limit Per Organization: </strong> {currentEvent.organization_registrant_limit}</p> */}
                        <p><strong>Has Judging: </strong> {currentEvent.has_judging ? 'Yes' : 'No'}</p>
                        {/* <p><strong>Requires Registrant Organization: </strong> {currentEvent.require_organization ? 'Yes' : 'No'}</p> */}
                        {/* <p><strong>Registration Fee: </strong>{currentEvent.registrant_fee != 0.0 ? `$${currentEvent.registrant_fee}`: `Free`}</p> */}
                        {/* <p><strong>Using Billing Service: </strong> {currentEvent.use_billing_service ? 'Yes' : 'No'}</p> */}
                        {/* <p><strong>Requesting Invoice: </strong> {currentEvent.use_invoice ? 'Yes' : 'No'}</p> */}


                        <div className='buttonsRow'>
                        {userRole?.host_id == currentEvent.host_id && userRole?.role_id == ROLES.ADMIN && (

                            <div className='buttonsLeft'>
                                        <button onClick={() => navigate(ROUTES.EDIT_EVENT)} style={{ marginRight: '10px' }} disabled={currentEvent.is_locked}>Edit Event</button>
                                        {currentEvent.event_type_id === 'MUSIC' && <button onClick={() => navigate(ROUTES.EDIT_EVENT_INSTRUMENTS)} style={{ marginRight: '10px' }} disabled={currentEvent.is_locked}>Change Instruments</button>}
                                        <button onClick={() => navigate(ROUTES.EVENT_LOGO)} style={{ marginRight: '10px' }} disabled={currentEvent.is_locked}>Change Event Logo</button>
                            </div>)}


                            <button onClick={() => navigate(ROUTES.SWITCH_EVENTS)} disabled={currentEvent.is_locked}>{currentEvent ? 'Switch Events' : 'Create New Event'}</button>

                        </div>
                    </div>
                    {(userRole?.host_id == currentEvent.host_id && userRole.role_id == ROLES.ADMIN ) && <EventControlsPage />}
                </div>


            );
        } else {
            return (
                <div className='card'>
                    <p>No current event selected.</p>
                    <button style={{ marginRight: '10px' }} onClick={() => navigate(ROUTES.SWITCH_EVENTS)}>Select an Event</button>
                    {userRole?.host_id != "" && (
                        <button onClick={() => navigate(ROUTES.CREATE_EVENT)}>Create New Event</button>
                    )}
                </div>
            );
        }
    };

    return (
        <div>
            {renderEventDetails()}
        </div>
    );
};


export default EventOverview;
